export default function MiddlePanelLoading() {
  const singleLoadingItem = (itemId: number) => {
    return (
      <div
        key={itemId}
        className="w-full md:h-[76px] h-[60px] animate-loading rounded-radius-xxl" // by using animate-loading class, apply the animation to the div and the background color added in tailwind utility(global css file).
        style={{ animationDelay: `${(4 - itemId) * 20}ms` }}
      />
    );
  };

  return (
    <div
      className="flex flex-col gap-spacing-m lg:gap-spacing-l"
      data-testid="skeleton-loaders-test-id"
    >
      {Array.from({ length: 5 }, (_, index) => singleLoadingItem(index))}
    </div>
  );
}
